<div fxLayout="column" fxLayoutGap="16px">
	<p class="h2">
		<span>{{ name }}</span>
		@if (!data.createField) {
			<span> {{ 'dialogs.textInputEditor.editor' | translate }}</span>
		}
	</p>
	<div fxLayout="column">
		<mat-form-field>
			<mat-label>{{ label }}</mat-label>
			@if (autocompleteOptions) {
				<input matInput [formControl]="inputForm" [placeholder]="placeholder" [matAutocomplete]="auto" />
				<mat-autocomplete #auto="matAutocomplete">
					@for (option of filteredAutocompleteOptions; track option.displayName) {
						<mat-option [value]="option.value">{{ option.displayName }}</mat-option>
					}
				</mat-autocomplete>
			} @else {
				<input matInput [formControl]="inputForm" [placeholder]="placeholder" />
			}
			@if (hint) {
				<mat-hint>{{ hint }}</mat-hint>
			}

			@if (maxLength) {
				<mat-hint align="end">{{ inputForm.value?.length }} / {{ maxLength }}</mat-hint>
			}

			@if (maxLength && inputForm.hasError('maxlength')) {
				<mat-error>Value cannot exceed {{ maxLength }} characters.</mat-error>
			}
		</mat-form-field>
	</div>
	<div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
		@if (isUpdating) {
			<mat-spinner [diameter]="24"></mat-spinner>
		}
		<button mat-raised-button (click)="cancel()" [disabled]="isUpdating">{{ 'common.cancel' | translate }}</button>
		<button mat-raised-button color="primary" (click)="update()" [disabled]="isUpdating || inputForm.invalid">{{ buttonText }}</button>
	</div>
</div>
